import React from 'react';
import { Input, Select, Button, Typography, Form } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { SearchCard } from '../../../components/sections/Hero/Hero.styles';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;
const { Option } = Select;

const SearchForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log('Giá trị tìm kiếm:', values);
    // TODO: Gửi dữ liệu search nếu cần
  };

  return (
    <SearchCard>
      <Title level={4}>Tìm kiếm phòng Fitness phù hợp</Title>
      <Form form={form} onFinish={onFinish}>
        <Form.Item name="location">
          <Input
            placeholder="Khu vực (ví dụ: Thanh Khê, Ngũ Hành Sơn, etc.)"
            size="large"
          />
        </Form.Item>

        <Form.Item name="priceRange">
          <Select
            placeholder="Chọn mức giá"
            style={{ width: '100%' }}
            size="large"
          >
            <Option value="under500k">Dưới 500.000đ</Option>
            <Option value="500k-1m">500.000đ - 1.000.000đ</Option>
            <Option value="1m-2m">1.000.000đ - 2.000.000đ</Option>
            <Option value="above2m">Trên 2.000.000đ</Option>
          </Select>
        </Form.Item>

        <Form.Item name="serviceType">
          <Select
            placeholder="Chọn loại hình dịch vụ"
            style={{ width: '100%' }}
            size="large"
          >
            <Option value="gym">Phòng Gym</Option>
            <Option value="yoga">Phòng Yoga</Option>
            <Option value="fitness">Trung tâm Fitness</Option>
            <Option value="swimming">Hồ bơi</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            size="large"
            style={{
              float: 'right',
              background: 'linear-gradient(to right, #14557B, #259BE1)'
            }}
            onClick={() => navigate('/list-fitness-center')}
          >
            Tìm kiếm
          </Button>
        </Form.Item>
      </Form>
    </SearchCard>
  );
};

export default SearchForm;
